<template>
  <div id="email-page">
    <emailer />
  </div>
</template>

<script>
import adminCheckerMixin from '@/mixins/adminChecker.mixin'

export default {
  mixins: [adminCheckerMixin],
    
  components: {
    Emailer: () => import('@/components/EmailTemplate/Emailer.vue'),
  },
};
</script>